import React, { useEffect,useState } from 'react';
import Datas from '../data/portfolio/filter.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/portfolioFilter.js";
import axios from 'axios';
import slugify from 'slugify';

function PortfolioFilter() {

    const [homePageService, setHomePageService] = useState([]);
    useEffect(() => {
        const getHomePageService = async () => {
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/homepage-services/find-all`).then((response) => setHomePageService(response.data))
            .catch((error) => console.error(error));
        }
        getHomePageService();
    },[])

    useEffect(() => {
        const buttons = document.querySelector(".filter-btn-list").children;
        const items = document.querySelector(".filter-items").children;

        for (let i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener("click", function () {

                for (let j = 0; j < buttons.length; j++) {
                    buttons[j].classList.remove("active");
                }

                this.classList.add("active");
                const target = this.getAttribute("data-target");

                for (let k = 0; k < items.length; k++) {
                    items[k].style.display = "none";

                    if (items[k].getAttribute("data-id") === target) {
                        items[k].style.display = "block";
                    }

                    if (target === "*") {
                        items[k].style.display = "block";
                    }
                }
            })
        }
    });

    return (
        <Styles>
            {/* Course Area */}
            <section className="course-filter">
                <Container>
                    <Row>
                        <Col md="12">
                            <div className="sec-title text-center">
                                <h4>{Datas.secTitle}</h4>
                            </div>
                        </Col>
                        <Col md="12">
                            <div className="filter-btns text-center">
                                <ul className="filter-btn-list list-unstyled list inline">
                                    <li data-target="*" className="active list-inline-item">All</li>
                                    <li data-target="buildM" className="list-inline-item">Building Management</li>
                                    <li data-target="faclM" className="list-inline-item">Facilities Management</li>
                                    <li data-target="deve" className="list-inline-item">Developer Services</li>
                                    <li data-target="concie" className="list-inline-item">Concierge</li>
                                    <li data-target="clean" className="list-inline-item">Cleaning</li>
                                    <li data-target="garland" className="list-inline-item">Gardening & Landscaping</li>
                                </ul>
                            </div>
                            <Row className="filter-items">
                                {
                                    homePageService && homePageService.length > 0 ? homePageService.map((data, i) => (
                                        <Col lg="4" md="6" key={i} data-id={data.targetId}>
                                            <div className="course-item">
                                                <Link to={process.env.PUBLIC_URL + "/" + data.urlSlug}>
                                                    <div className="course-image" style={{backgroundImage: `url(${process.env.REACT_APP_API_BASE_URL.substring(0, process.env.REACT_APP_API_BASE_URL.indexOf("/api")) + `${data.serviceImg.substring(data.serviceImg.indexOf("/uploads"))}`})`}}>
                                                    </div>
                                                    
                                                </Link>
                                                <div className="course-content">
                                                    <h6 className="heading"><Link to={process.env.PUBLIC_URL + "/" +  data.urlSlug}>{data.serviceName}</Link></h6>
                                                    <p className="desc" dangerouslySetInnerHTML={{ __html: data.serviceDesc}}></p>
                                                   
                                                </div>
                                            </div>
                                        </Col>
                                    )) : "No home page content"
                                }
                            </Row>
                        </Col>
                        <Col md="12" className="text-center">
                            <div className="viewall-btn">
                                <Link to={process.env.PUBLIC_URL + "/services"}>View All Services</Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default PortfolioFilter
